import Marquee from "react-fast-marquee";

const ITEMS = [
  "LIVE INVENTORY",
  "SECURE SUBSTITUTES",
  "FAST DELIVERY",
  "LOCAL PHARMACIES",
  "REAL-TIME STOCK",
  "UNDER AN HOUR",
];

export const BrandMarquee = () => {
  return (
    <section
      className="border-y border-slate-100 bg-slate-50 py-8"
      data-testid="brand-marquee"
      aria-hidden="true"
    >
      <Marquee speed={38} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display px-8 text-3xl font-extrabold tracking-tight text-slate-300 sm:text-4xl">
              {item}
            </span>
            <span
              className="h-2.5 w-2.5 rounded-full"
              style={{ backgroundColor: "var(--action-green)" }}
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default BrandMarquee;
